// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import FunnelSvg from '@rsuite/icon-font/lib/action/Funnel';
var Funnel = createSvgIcon({
  as: FunnelSvg,
  ariaLabel: 'funnel',
  category: 'action',
  displayName: 'Funnel'
});
export default Funnel;